<template  >
    <div class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 py-5 py-lg-0">
        <div class="col-12 d-flex flex-wrap h-100 justify-content-center align-items-center align-content-center overflow-hidden position-relative">  
            <div class="col-12 d-flex justify-content-center text-center align-items-center flex-wrap px-lg-4">
                <span class="font- fuente-posm label-1 d-flex flex-wrap">Sorprende a tus Clientes</span>
            </div>
            <div class="col-12 d-flex justify-content-center text-center align-items-center flex-wrap px-lg-4 mt-5">
                <button
                    class="button-outline gray font- fuente-nova2 py-3 px-5 hover-boton_mod"
                    @click="showModal"
                >
                    Contáctanos Ahora
                </button>
            </div>
        </div>
    </div>  
</template>

<script>
import { openContactModal } from '@/utils/modalHelper'

export default {
    name: 'page12',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a1: require('@/assets/images/a1.png'),
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        },
        showModal() {
            openContactModal(); // se puede pasar un identificador si lo necesitas
        }
    },
}
</script>

<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

.label-1 {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    max-width: 750px;
    word-wrap: break-word;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 28px;
    }
}
</style>
